import Modal from '@components/Modal'
import React from 'react'
import {
	CancelButton,
	ConfirmationActions,
	ConfirmationContent,
	ConfirmationMessage,
	ConfirmButton,
} from './ConfirmationModal.styles'
import { TestIds } from '@/testIds'

interface ConfirmationModalProps {
	isOpen: boolean
	onClose: () => void
	onConfirm: () => void
	title: string
	message: string | React.ReactNode
	confirmText?: string
	cancelText?: string
	variant?: 'danger' | 'warning' | 'info'
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
	isOpen,
	onClose,
	onConfirm,
	title,
	message,
	confirmText = 'Confirm',
	cancelText = 'Cancel',
	variant = 'danger',
}) => {
	const handleConfirm = () => {
		onConfirm()
		onClose()
	}

	return (
		<Modal isOpen={isOpen} onClose={onClose} title={title} size="small" closeOnBackdropClick={false}>
			<ConfirmationContent>
				<ConfirmationMessage>{message}</ConfirmationMessage>
				<ConfirmationActions>
					<CancelButton onClick={onClose}>{cancelText}</CancelButton>
					<ConfirmButton
						variant={variant === 'danger' ? 'danger' : 'primary'}
						onClick={handleConfirm}
						data-testid={TestIds.common.popupConfirm}
					>
						{confirmText}
					</ConfirmButton>
				</ConfirmationActions>
			</ConfirmationContent>
		</Modal>
	)
}

export default ConfirmationModal
